import { Form, Row, Col, Button, Input } from "antd";

function EmailFollowSearch(props: any) {
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    let query = "";

    if (values.email) {
      query += `&email=${values.email}`;
    }

    if (values.email) {
      props.handleSearch(query);
    } else {
      props.handleSearch("");
    }
  };

  const resetForm = () => {
    form.resetFields();
  };
  return (
    <Form form={form} onFinish={onFinish}>
      <Row
        gutter={24}
        style={{
          background: "#fff",
          paddingTop: 25,
          margin: 0,
          marginBottom: 20,
          borderRadius: 6,
        }}>
        <Col span={16}>
          <Form.Item name="email" label="Email">
            <Input placeholder="Tìm kiếm tên email..." />
          </Form.Item>
        </Col>
        <Col
          span={8}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 25,
          }}>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
            style={{ marginRight: 12 }}>
            Tìm kiếm
          </Button>
          <Button type="primary" danger onClick={resetForm}>
            Làm lại
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default EmailFollowSearch;
